import React from "react"
import { CheckIcon } from "gatsby-interface"
import { Collection, CollectionItem } from "@modules/ui/components/Collection"

const greenIconCss = theme => ({
  fill: theme.colors.green[50],
})

export function PlanFeatures({ list }) {
  return (
    <Collection>
      {list.map(feature => (
        <CollectionItem Icon={<CheckIcon css={greenIconCss} />} key={feature}>
          {feature}
        </CollectionItem>
      ))}
    </Collection>
  )
}
